module.exports = __webpack_public_path__ + "img/trade-bg-7bc0d5.jpg";